import { Seo } from "../components/onix/Seo";
import { SectionEyebrow } from "../components/onix/SectionEyebrow";
import { Reveal } from "../components/onix/Reveal";
import { CTASection } from "../components/onix/CTASection";
import { CinematicScene } from "../components/onix/CinematicScene";
import { useLang } from "../i18n/LanguageContext";

export default function Empresa() {
  const { t } = useLang();
  const te = t.emp;
  return (
    <main className="pt-[76px]">
      <Seo title={te.seoTitle} description={te.seoDesc} path="/empresa" />

      <CinematicScene img="/assets/img/emp_lab.webp" imgMobile="/assets/img/emp_lab_m.webp" eager data-testid="emp-scene-hero">
        <section className="onix-shell py-24 md:py-40 border-b border-onix-line">
          <Reveal>
            <SectionEyebrow index="01" label={te.label} />
            <h1 className="text-[2rem] leading-[1.1] sm:text-5xl lg:text-6xl font-bold font-serif sm:leading-[1.05] text-onix-white max-w-4xl mb-8 break-words">
              {te.h1}
            </h1>
            <p className="text-base md:text-lg leading-relaxed text-onix-silver max-w-2xl">{te.intro}</p>
          </Reveal>
        </section>
      </CinematicScene>

      <CinematicScene img="/assets/img/emp_enfoque.webp" imgMobile="/assets/img/emp_enfoque_m.webp" data-testid="emp-scene-enfoque">
        <section className="onix-shell py-20 md:py-32">
          <Reveal>
            <SectionEyebrow index="02" label={te.enfoqueLabel} />
          </Reveal>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
            {te.approach.map((a, i) => (
              <Reveal key={a.num} delay={Math.min(i * 0.06, 0.25)}>
                <div data-testid={`approach-${a.num}`} className="border border-onix-line bg-onix-black2 p-7 h-full">
                  <span className="tech-label block mb-6">{a.num}</span>
                  <h2 className="font-sans font-bold text-base text-onix-white mb-3">{a.title}</h2>
                  <p className="text-sm leading-relaxed text-onix-silver">{a.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </section>
      </CinematicScene>

      <CinematicScene img="/assets/img/emp_ops.webp" imgMobile="/assets/img/emp_ops_m.webp" className="border-t border-onix-line" data-testid="emp-scene-ops">
        <section data-testid="operations-section">
          <div className="onix-shell py-20 md:py-32">
            <Reveal>
              <SectionEyebrow index="03" label={te.opsLabel} />
            </Reveal>
            <div className="grid lg:grid-cols-12 gap-10 mb-14">
              <Reveal className="lg:col-span-5">
                <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold font-serif text-onix-white">{te.opsTitle}</h2>
              </Reveal>
              <Reveal className="lg:col-span-7" delay={0.1}>
                <p className="text-base leading-relaxed text-onix-silver lg:pt-3">{te.opsText}</p>
              </Reveal>
            </div>
            <div className="grid md:grid-cols-12 gap-5">
              <Reveal className="md:col-span-7">
                <figure className="border border-onix-line">
                  <img
                    data-testid="ops-image-wide"
                    src="/assets/img/onix_lab_wide.jpg"
                    alt={te.opsAlt1}
                    loading="lazy"
                    decoding="async"
                    className="w-full h-auto block grayscale"
                  />
                </figure>
              </Reveal>
              <Reveal className="md:col-span-5" delay={0.1}>
                <figure className="border border-onix-line">
                  <img
                    data-testid="ops-image-detail"
                    src="/assets/img/onix_lab_detail.jpg"
                    alt={te.opsAlt2}
                    loading="lazy"
                    decoding="async"
                    className="w-full h-auto block grayscale"
                  />
                </figure>
              </Reveal>
            </div>
          </div>
        </section>
      </CinematicScene>

      <CinematicScene img="/assets/img/onix_scene_5.webp" imgMobile="/assets/img/onix_scene_5_m.webp" data-testid="emp-scene-cta">
        <CTASection
          index="04"
          label={t.common.contactoLabel}
          title={te.ctaTitle}
          text={te.ctaText}
          buttonLabel={t.common.hablarConOnix}
          to="/contacto"
        />
      </CinematicScene>
    </main>
  );
}
